import React, { lazy } from "react";

const AccountOverview = lazy(() =>
  import(/* webpackChunkName: "account-overview" */ "../pages/account/AccountOverview")
);
const AccountUsage = lazy(() =>
  import(/* webpackChunkName: "account-usage" */ "../pages/AccountUsage")
);
const Billing = lazy(() =>
  import(/* webpackChunkName: "account-billing" */ "../pages/Billing")
);
const Subscriptions = lazy(() =>
  import(/* webpackChunkName: "account-subscriptions" */ "../pages/account/Subscriptions")
);
const BillingSuccess = lazy(() =>
  import(/* webpackChunkName: "account-billing-success" */ "../pages/BillingSuccess")
);
const Monitoring = lazy(() =>
  import(/* webpackChunkName: "account-monitoring" */ "../pages/account/Monitoring")
);
const ApiKeys = lazy(() =>
  import(/* webpackChunkName: "account-api-keys" */ "../pages/account/ApiKeys")
);
const AccountSettings = lazy(() =>
  import(/* webpackChunkName: "account-settings" */ "../pages/account/Settings")
);
const AuditsList = lazy(() =>
  import(/* webpackChunkName: "account-audits-list" */ "../pages/account/AuditsList")
);
const AuditSubmit = lazy(() =>
  import(/* webpackChunkName: "account-audit-submit" */ "../pages/account/AuditSubmit")
);
const AuditDetail = lazy(() =>
  import(/* webpackChunkName: "account-audit-detail" */ "../pages/account/AuditDetail")
);
const AccountWebhooks = lazy(() =>
  import(/* webpackChunkName: "account-webhooks" */ "../pages/account/Webhooks")
);
const CustomEnterprise = lazy(() =>
  import(/* webpackChunkName: "account-custom-enterprise" */ "../pages/account/CustomEnterprise")
);
const EnterpriseEngagement = lazy(() =>
  import(/* webpackChunkName: "account-enterprise-engagement" */ "../pages/account/EnterpriseEngagement")
);
const QuickStartPage = lazy(() =>
  import(/* webpackChunkName: "account-quickstart" */ "../pages/account/QuickStart")
);
const NdaCenter = lazy(() =>
  import(/* webpackChunkName: "account-nda" */ "../pages/account/NdaCenter")
);
const PqcInventory = lazy(() =>
  import(/* webpackChunkName: "account-pqc-inventory" */ "../pages/account/PqcInventory")
);
// M3a Step 3 — CBOM (Cryptographic Bill of Materials) generator
const CbomGenerator = lazy(() =>
  import(/* webpackChunkName: "account-cbom" */ "../pages/account/CbomGenerator")
);
const AccountContacts = lazy(() =>
  import(/* webpackChunkName: "account-contacts" */ "../pages/account/Contacts")
);
const CustomerThreatRadarEditor = lazy(() =>
  import(/* webpackChunkName: "account-threat-radar" */ "../pages/account/CustomerThreatRadarEditor")
);
// Wave 3 — Referral / Affiliate program
const MyReferrals = lazy(() =>
  import(/* webpackChunkName: "account-referrals" */ "../pages/account/MyReferrals")
);

const accountRoutes = [
  { path: "/account", element: <AccountOverview /> },
  { path: "/account/usage", element: <AccountUsage /> },
  { path: "/account/billing", element: <Billing /> },
  { path: "/account/subscriptions", element: <Subscriptions /> },
  { path: "/account/billing/success", element: <BillingSuccess /> },
  { path: "/account/monitoring", element: <Monitoring /> },
  { path: "/account/api-keys", element: <ApiKeys /> },
  { path: "/account/settings", element: <AccountSettings /> },
  { path: "/account/audits", element: <AuditsList /> },
  { path: "/account/audits/new", element: <AuditSubmit /> },
  { path: "/account/audits/:id", element: <AuditDetail /> },
  { path: "/account/webhooks", element: <AccountWebhooks /> },
  { path: "/account/custom-enterprise", element: <CustomEnterprise /> },
  { path: "/account/enterprise/:intakeId", element: <EnterpriseEngagement /> },
  { path: "/account/quickstart", element: <QuickStartPage /> },
  { path: "/account/nda", element: <NdaCenter /> },
  { path: "/account/inventory", element: <PqcInventory /> },
  { path: "/account/cbom",      element: <CbomGenerator /> },
  { path: "/account/contacts", element: <AccountContacts /> },
  { path: "/account/threat-radar", element: <CustomerThreatRadarEditor /> },
  { path: "/account/referrals",    element: <MyReferrals /> },
];

export default accountRoutes;
